export class PopMenuInfo {
    id: string;
    parentId: string;
    icon: string;
    name: string;
    text: string;
    path: string;
    selected: boolean;
    bookmarked: boolean;
    disable: boolean;
    visibleIndex: number;
    isWorkspace: boolean;
    isInternal? = false;
    isSpecificRole? = false;
    items: PopMenuInfo[];
    hasAccess? = true;
    visible? = true;
}
